import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">
          {aboutData.title}
        </h2>
        <div className="relative">
          <div className="absolute -top-4 left-4 text-6xl text-primary-200 font-heading leading-none select-none">
            "
          </div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed px-4">
            {aboutData.content}
          </p>
          <div className="absolute -bottom-4 right-4 text-6xl text-primary-200 font-heading leading-none select-none">
            "
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-background-100 rounded-2xl p-4 border border-background-200/60">
            <div className="text-2xl font-heading text-primary-500">2018</div>
            <div className="text-foreground-400 text-xs mt-1">创立年份</div>
          </div>
          <div className="bg-background-100 rounded-2xl p-4 border border-background-200/60">
            <div className="text-2xl font-heading text-accent-500">100万+</div>
            <div className="text-foreground-400 text-xs mt-1">日活用户</div>
          </div>
          <div className="bg-background-100 rounded-2xl p-4 border border-background-200/60">
            <div className="text-2xl font-heading text-secondary-500">5000万+</div>
            <div className="text-foreground-400 text-xs mt-1">累计服务</div>
          </div>
          <div className="bg-background-100 rounded-2xl p-4 border border-background-200/60">
            <div className="text-2xl font-heading text-primary-500">200+</div>
            <div className="text-foreground-400 text-xs mt-1">每日更新</div>
          </div>
        </div>
      </div>
    </section>
  );
}